// extracted by mini-css-extract-plugin
export default {"maintenance":"maintenance_maintenance__ZI-ua","main":"maintenance_main__zPYJx","footer":"maintenance_footer__kyDyc"};